import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Services from '../components/Services';
import WhyChooseUs from '../components/WhyChooseUs';
import Pricing from '../components/Pricing';
import Testimonials from '../components/Testimonials';
import FAQ from '../components/FAQ';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import { Toaster } from '../components/ui/sonner';

const Home = () => {
  const handleGetQuote = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <Header onGetQuote={handleGetQuote} />
      
      <main className="pt-20">
        <Hero onGetQuote={handleGetQuote} />
        <Services />
        <div id="about">
          <WhyChooseUs />
        </div>
        <Pricing />
        <div id="testimonials">
          <Testimonials />
        </div>
        <div id="faq">
          <FAQ />
        </div>
        <Contact />
      </main>

      <Footer />
      <Toaster position="top-right" />
    </>
  );
};

export default Home;
